import ApiService from '@/services/ApiService';

export default {
  getAll() {
    return ApiService()
      .get('/expense-category/list');
  },
};
